import countries from "../../countries.json";

const forms = [
  {
    name: "Details",
    options: [
      {
        name: "Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Salesman name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Code",
        type: "input",
        form: {
          type: "text",
          name: "code",
          placeholder: "Salesman code",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Contact Details",
    options: [
      {
        name: "Email",
        type: "input",
        form: {
          type: "text",
          name: "email",
          placeholder: "Salesman email",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Phone",
        type: "input",
        form: {
          type: "text",
          name: "phone",
          placeholder: "Salesman phone",
          class: "",
          value: "",
          required: false,
        },
      }
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
